import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 1);
    }
  }, [pathname, hash]);

  return null;
}
